<div *ngIf="ready && page" class="content">
    <div class="document-col">
        <div class="sheet">
            <div class="sheet-header">
                <kd-breadcrumbs class="breadcrumbs"></kd-breadcrumbs>
                <kd-version></kd-version>
            </div>

            <kd-release-notes *ngIf="isReleaseNotes()" [page]="page"></kd-release-notes>
            <kd-document *ngIf="!isReleaseNotes()" [content]="contentString"></kd-document>
        </div>
    </div>

    <div class="headlines-col">
        <kd-headlines></kd-headlines>
    </div>
</div>

<div *ngIf="ready && !page" class="error">
    <kd-not-found></kd-not-found>
</div>
